module.exports = __webpack_public_path__ + "img/icon_map_5_6_c.0ebcdddd.png";